import { render, staticRenderFns } from "./JEditorChangeUrl.vue?vue&type=template&id=4efcf3ee&scoped=true&"
import script from "./JEditorChangeUrl.vue?vue&type=script&lang=js&"
export * from "./JEditorChangeUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efcf3ee",
  null
  
)

export default component.exports